import React from 'react'
import { InsurancePlan } from '@teschglobal/tg-fhir-react-components'
import type { InsurancePlan as FHIRInsurancePlan} from '@teschglobal/tg-fhir-react-components/dist/types'
import useFhirConfig from '../../../../../hooks/admin/useFhirConfig'

type InsurancePlanDetailProps = {
  resource: FHIRInsurancePlan | null | undefined
}

const InsurancePlanDetail: React.FC<InsurancePlanDetailProps> = ({ resource }) => {
  const { providerDirectoryFhirConfig, handleSelectOrganization } = useFhirConfig()

  if (!resource) {
    return (
      <div className="text-center" role="status" aria-live="polite" aria-atomic="true">
        Not Found
      </div>
    )
  }

  return (
    <section>
      <h3>InsurancePlan</h3>
      <InsurancePlan
        data={resource}
        fhirApiConfig={providerDirectoryFhirConfig}
        onSelectOrganization={handleSelectOrganization}
      />
    </section>
  )
}

export default InsurancePlanDetail
